import styles from "./styles.module.css";

<template>
  <div data-test-button-group ...attributes>
    <div class="{{styles.root}} inline-flex items-stretch rounded-sm border border-gray-200 divide-x divide-gray-400">
      {{yield}}
    </div>
  </div>
</template>
